import React from 'react';
import { Line } from 'react-chartjs-2';

const data = {
  labels: ['6/1/21 0:00',
    '6/1/21 1:00',
    '6/1/21 2:00',
    '6/1/21 3:00',
    '6/1/21 4:00',
    '6/1/21 5:00',
    '6/1/21 6:00',
    '6/1/21 7:00',
    '6/1/21 8:00',
    '6/1/21 9:00',
    '6/1/21 10:00',
    '6/1/21 11:00',
    '6/1/21 12:00',
    '6/1/21 13:00',
    '6/1/21 14:00',
    '6/1/21 15:00',
    '6/1/21 16:00',
    '6/1/21 17:00',
    '6/1/21 18:00',
    '6/1/21 19:00',
    '6/1/21 20:00',
    '6/1/21 21:00',
    '6/1/21 22:00',
    '6/1/21 23:00',
    '6/2/21 0:00',
    '6/2/21 1:00',
    '6/2/21 2:00',
    '6/2/21 3:00',
    '6/2/21 4:00',
    '6/2/21 5:00',
    '6/2/21 6:00',
    '6/2/21 7:00',
    '6/2/21 8:00',
    '6/2/21 9:00',
    '6/2/21 10:00',
    '6/2/21 11:00',
    '6/2/21 12:00',
    '6/2/21 13:00',
    '6/2/21 14:00',
    '6/2/21 15:00',
    '6/2/21 16:00',
    '6/2/21 17:00',
    '6/2/21 18:00',
    '6/2/21 19:00',
    '6/2/21 20:00',
    '6/2/21 21:00',
    '6/2/21 22:00',
    '6/2/21 23:00',
    '6/3/21 0:00',
    '6/3/21 1:00',
    '6/3/21 2:00',
    '6/3/21 3:00',
    '6/3/21 4:00',
    '6/3/21 5:00',
    '6/3/21 6:00',
    '6/3/21 7:00',
    '6/3/21 8:00',
    '6/3/21 9:00',
    '6/3/21 10:00',
    '6/3/21 11:00',
    '6/3/21 12:00',
    '6/3/21 13:00',
    '6/3/21 14:00',
    '6/3/21 15:00',
    '6/3/21 16:00',
    '6/3/21 17:00',
    '6/3/21 18:00',
    '6/3/21 19:00',
    '6/3/21 20:00',
    '6/3/21 21:00',
    '6/3/21 22:00',
    '6/3/21 23:00',
    '6/4/21 0:00',
    '6/4/21 1:00',
    '6/4/21 2:00',
    '6/4/21 3:00',
    '6/4/21 4:00',
    '6/4/21 5:00',
    '6/4/21 6:00',
    '6/4/21 7:00',
    '6/4/21 8:00',
    '6/4/21 9:00',
    '6/4/21 10:00',
    '6/4/21 11:00',
    '6/4/21 12:00',
    '6/4/21 13:00',
    '6/4/21 14:00',
    '6/4/21 15:00',
    '6/4/21 16:00',
    '6/4/21 17:00',
    '6/4/21 18:00',
    '6/4/21 19:00',
    '6/4/21 20:00',
    '6/4/21 21:00',
    '6/4/21 22:00',
    '6/4/21 23:00',
    '6/5/21 0:00',
    '6/5/21 1:00',
    '6/5/21 2:00',
    '6/5/21 3:00',
    '6/5/21 4:00',
    '6/5/21 5:00',
    '6/5/21 6:00',
    '6/5/21 7:00',
    '6/5/21 8:00',
    '6/5/21 9:00',
    '6/5/21 10:00',
    '6/5/21 11:00',
    '6/5/21 12:00',
    '6/5/21 13:00',
    '6/5/21 14:00',
    '6/5/21 15:00',
    '6/5/21 16:00',
    '6/5/21 17:00',
    '6/5/21 18:00',
    '6/5/21 19:00',
    '6/5/21 20:00',
    '6/5/21 21:00',
    '6/5/21 22:00',
    '6/5/21 23:00',
    '6/6/21 0:00',
    '6/6/21 1:00',
    '6/6/21 2:00',
    '6/6/21 3:00',
    '6/6/21 4:00',
    '6/6/21 5:00',
    '6/6/21 6:00',
    '6/6/21 7:00',
    '6/6/21 8:00',
    '6/6/21 9:00',
    '6/6/21 10:00',
    '6/6/21 11:00',
    '6/6/21 12:00',
    '6/6/21 13:00',
    '6/6/21 14:00',
    '6/6/21 15:00',
    '6/6/21 16:00',
    '6/6/21 17:00',
    '6/6/21 18:00',
    '6/6/21 19:00',
    '6/6/21 20:00',
    '6/6/21 21:00',
    '6/6/21 22:00',
    '6/6/21 23:00',
    '6/7/21 0:00',
    '6/7/21 1:00',
    '6/7/21 2:00',
    '6/7/21 3:00',
    '6/7/21 4:00',
    '6/7/21 5:00',
    '6/7/21 6:00',
    '6/7/21 7:00',
    '6/7/21 8:00',
    '6/7/21 9:00',
    '6/7/21 10:00',
    '6/7/21 11:00',
    '6/7/21 12:00',
    '6/7/21 13:00',
    '6/7/21 14:00',
    '6/7/21 15:00',
    '6/7/21 16:00',
    '6/7/21 17:00',
    '6/7/21 18:00',
    '6/7/21 19:00',
    '6/7/21 20:00',
    '6/7/21 21:00',
    '6/7/21 22:00',
    '6/7/21 23:00',
    '6/8/21 0:00',
    '6/8/21 1:00',
    '6/8/21 2:00',
    '6/8/21 3:00',
    '6/8/21 4:00',
    '6/8/21 5:00',
    '6/8/21 6:00',
    '6/8/21 7:00',
    '6/8/21 8:00',
    '6/8/21 9:00',
    '6/8/21 10:00',
    '6/8/21 11:00',
    '6/8/21 12:00',
    '6/8/21 13:00',
    '6/8/21 14:00',
    '6/8/21 15:00',
    '6/8/21 16:00',
    '6/8/21 17:00',
    '6/8/21 18:00',
    '6/8/21 19:00',
    '6/8/21 20:00',
    '6/8/21 21:00',
    '6/8/21 22:00',
    '6/8/21 23:00',
    '6/9/21 0:00',
    '6/9/21 1:00',
    '6/9/21 2:00',
    '6/9/21 3:00',
    '6/9/21 4:00',
    '6/9/21 5:00',
    '6/9/21 6:00',
    '6/9/21 7:00',
    '6/9/21 8:00',
    '6/9/21 9:00',
    '6/9/21 10:00',
    '6/9/21 11:00',
    '6/9/21 12:00',
    '6/9/21 13:00',
    '6/9/21 14:00',
    '6/9/21 15:00',
    '6/9/21 16:00',
    '6/9/21 17:00',
    '6/9/21 18:00',
    '6/9/21 19:00',
    '6/9/21 20:00',
    '6/9/21 21:00',
    '6/9/21 22:00',
    '6/9/21 23:00',
    '6/10/21 0:00',
    '6/10/21 1:00',
    '6/10/21 2:00',
    '6/10/21 3:00',
    '6/10/21 4:00',
    '6/10/21 5:00',
    '6/10/21 6:00',
    '6/10/21 7:00',
    '6/10/21 8:00',
    '6/10/21 9:00',
    '6/10/21 10:00',
    '6/10/21 11:00',
    '6/10/21 12:00',
    '6/10/21 13:00',
    '6/10/21 14:00',
    '6/10/21 15:00',
    '6/10/21 16:00',
    '6/10/21 17:00',
    '6/10/21 18:00',
    '6/10/21 19:00',
    '6/10/21 20:00',
    '6/10/21 21:00',
    '6/10/21 22:00',
    '6/10/21 23:00',
    '6/11/21 0:00',
    '6/11/21 1:00',
    '6/11/21 2:00',
    '6/11/21 3:00',
    '6/11/21 4:00',
    '6/11/21 5:00',
    '6/11/21 6:00',
    '6/11/21 7:00',
    '6/11/21 8:00',
    '6/11/21 9:00',
    '6/11/21 10:00',
    '6/11/21 11:00',
    '6/11/21 12:00',
    '6/11/21 13:00',
    '6/11/21 14:00',
    '6/11/21 15:00',
    '6/11/21 16:00',
    '6/11/21 17:00',
    '6/11/21 18:00',
    '6/11/21 19:00',
    '6/11/21 20:00',
    '6/11/21 21:00',
    '6/11/21 22:00',
    '6/11/21 23:00',
    '6/12/21 0:00',
    '6/12/21 1:00',
    '6/12/21 2:00',
    '6/12/21 3:00',
    '6/12/21 4:00',
    '6/12/21 5:00',
    '6/12/21 6:00',
    '6/12/21 7:00',
    '6/12/21 8:00',
    '6/12/21 9:00',
    '6/12/21 10:00',
    '6/12/21 11:00',
    '6/12/21 12:00',
    '6/12/21 13:00',
    '6/12/21 14:00',
    '6/12/21 15:00',
    '6/12/21 16:00',
    '6/12/21 17:00',
    '6/12/21 18:00',
    '6/12/21 19:00',
    '6/12/21 20:00',
    '6/12/21 21:00',
    '6/12/21 22:00',
    '6/12/21 23:00',
    '6/13/21 0:00',
    '6/13/21 1:00',
    '6/13/21 2:00',
    '6/13/21 3:00',
    '6/13/21 4:00',
    '6/13/21 5:00',
    '6/13/21 6:00',
    '6/13/21 7:00',
    '6/13/21 8:00',
    '6/13/21 9:00',
    '6/13/21 10:00',
    '6/13/21 11:00',
    '6/13/21 12:00',
    '6/13/21 13:00',
    '6/13/21 14:00',
    '6/13/21 15:00',
    '6/13/21 16:00',
    '6/13/21 17:00',
    '6/13/21 18:00',
    '6/13/21 19:00',
    '6/13/21 20:00',
    '6/13/21 21:00',
    '6/13/21 22:00',
    '6/13/21 23:00',
    '6/14/21 0:00',
    '6/14/21 1:00',
    '6/14/21 2:00',
    '6/14/21 3:00',
    '6/14/21 4:00',
    '6/14/21 5:00',
    '6/14/21 6:00',
    '6/14/21 7:00',
    '6/14/21 8:00',
    '6/14/21 9:00',
    '6/14/21 10:00',
    '6/14/21 11:00',
    '6/14/21 12:00',
    '6/14/21 13:00',
    '6/14/21 14:00',
    '6/14/21 15:00',
    '6/14/21 16:00',
    '6/14/21 17:00',
    '6/14/21 18:00',
    '6/14/21 19:00',
    '6/14/21 20:00',
    '6/14/21 21:00',
    '6/14/21 22:00',
    '6/14/21 23:00',
    '6/15/21 0:00',
    '6/15/21 1:00',
    '6/15/21 2:00',
    '6/15/21 3:00',
    '6/15/21 4:00',
    '6/15/21 5:00',
    '6/15/21 6:00',
    '6/15/21 7:00',
    '6/15/21 8:00',
    '6/15/21 9:00',
    '6/15/21 10:00',
    '6/15/21 11:00',
    '6/15/21 12:00',
    '6/15/21 13:00',
    '6/15/21 14:00',
    '6/15/21 15:00',
    '6/15/21 16:00',
    '6/15/21 17:00',
    '6/15/21 18:00',
    '6/15/21 19:00',
    '6/15/21 20:00',
    '6/15/21 21:00',
    '6/15/21 22:00',
    '6/15/21 23:00',
    '6/16/21 0:00',
    '6/16/21 1:00',
    '6/16/21 2:00',
    '6/16/21 3:00',
    '6/16/21 4:00',
    '6/16/21 5:00',
    '6/16/21 6:00',
    '6/16/21 7:00',
    '6/16/21 8:00',
    '6/16/21 9:00',
    '6/16/21 10:00',
    '6/16/21 11:00',
    '6/16/21 12:00',
    '6/16/21 13:00',
    '6/16/21 14:00',
    '6/16/21 15:00',
    '6/16/21 16:00',
    '6/16/21 17:00',
    '6/16/21 18:00',
    '6/16/21 19:00',
    '6/16/21 20:00',
    '6/16/21 21:00',
    '6/16/21 22:00',
    '6/16/21 23:00',
    '6/17/21 0:00',
    '6/17/21 1:00',
    '6/17/21 2:00',
    '6/17/21 3:00',
    '6/17/21 4:00',
    '6/17/21 5:00',
    '6/17/21 6:00',
    '6/17/21 7:00',
    '6/17/21 8:00',
    '6/17/21 9:00',
    '6/17/21 10:00',
    '6/17/21 11:00',
    '6/17/21 12:00',
    '6/17/21 13:00',
    '6/17/21 14:00',
    '6/17/21 15:00',
    '6/17/21 16:00',
    '6/17/21 17:00',
    '6/17/21 18:00',
    '6/17/21 19:00',
    '6/17/21 20:00',
    '6/17/21 21:00',
    '6/17/21 22:00',
    '6/17/21 23:00',
    '6/18/21 0:00',
    '6/18/21 1:00',
    '6/18/21 2:00',
    '6/18/21 3:00',
    '6/18/21 4:00',
    '6/18/21 5:00',
    '6/18/21 6:00',
    '6/18/21 7:00',
    '6/18/21 8:00',
    '6/18/21 9:00',
    '6/18/21 10:00',
    '6/18/21 11:00',
    '6/18/21 12:00',
    '6/18/21 13:00',
    '6/18/21 14:00',
    '6/18/21 15:00',
    '6/18/21 16:00',
    '6/18/21 17:00',
    '6/18/21 18:00',
    '6/18/21 19:00',
    '6/18/21 20:00',
    '6/18/21 21:00',
    '6/18/21 22:00',
    '6/18/21 23:00',
    '6/19/21 0:00',
    '6/19/21 1:00',
    '6/19/21 2:00',
    '6/19/21 3:00',
    '6/19/21 4:00',
    '6/19/21 5:00',
    '6/19/21 6:00',
    '6/19/21 7:00',
    '6/19/21 8:00',
    '6/19/21 9:00',
    '6/19/21 10:00',
    '6/19/21 11:00',
    '6/19/21 12:00',
    '6/19/21 13:00',
    '6/19/21 14:00',
    '6/19/21 15:00',
    '6/19/21 16:00',
    '6/19/21 17:00',
    '6/19/21 18:00',
    '6/19/21 19:00',
    '6/19/21 20:00',
    '6/19/21 21:00',
    '6/19/21 22:00',
    '6/19/21 23:00',
    '6/20/21 0:00',
    '6/20/21 1:00',
    '6/20/21 2:00',
    '6/20/21 3:00',
    '6/20/21 4:00',
    '6/20/21 5:00',
    '6/20/21 6:00',
    '6/20/21 7:00',
    '6/20/21 8:00',
    '6/20/21 9:00',
    '6/20/21 10:00',
    '6/20/21 11:00',
    '6/20/21 12:00',
    '6/20/21 13:00',
    '6/20/21 14:00',
    '6/20/21 15:00',
    '6/20/21 16:00',
    '6/20/21 17:00',
    '6/20/21 18:00',
    '6/20/21 19:00',
    '6/20/21 20:00',
    '6/20/21 21:00',
    '6/20/21 22:00',
    '6/20/21 23:00',
    '6/21/21 0:00',
    '6/21/21 1:00',
    '6/21/21 2:00',
    '6/21/21 3:00',
    '6/21/21 4:00',
    '6/21/21 5:00',
    '6/21/21 6:00',
    '6/21/21 7:00',
    '6/21/21 8:00',
    '6/21/21 9:00',
    '6/21/21 10:00',
    '6/21/21 11:00',
    '6/21/21 12:00',
    '6/21/21 13:00',
    '6/21/21 14:00',
    '6/21/21 15:00',
    '6/21/21 16:00',
    '6/21/21 17:00',
    '6/21/21 18:00',
    '6/21/21 19:00',
    '6/21/21 20:00',
    '6/21/21 21:00',
    '6/21/21 22:00',
    '6/21/21 23:00',
    '6/22/21 0:00',
    '6/22/21 1:00',
    '6/22/21 2:00',
    '6/22/21 3:00',
    '6/22/21 4:00',
    '6/22/21 5:00',
    '6/22/21 6:00',
    '6/22/21 7:00',
    '6/22/21 8:00',
    '6/22/21 9:00',
    '6/22/21 10:00',
    '6/22/21 11:00',
    '6/22/21 12:00',
    '6/22/21 13:00',
    '6/22/21 14:00',
    '6/22/21 15:00',
    '6/22/21 16:00',
    '6/22/21 17:00',
    '6/22/21 18:00',
    '6/22/21 19:00',
    '6/22/21 20:00',
    '6/22/21 21:00',
    '6/22/21 22:00',
    '6/22/21 23:00',
    '6/23/21 0:00',
    '6/23/21 1:00',
    '6/23/21 2:00',
    '6/23/21 3:00',
    '6/23/21 4:00',
    '6/23/21 5:00',
    '6/23/21 6:00',
    '6/23/21 7:00',
    '6/23/21 8:00',
    '6/23/21 9:00',
    '6/23/21 10:00',
    '6/23/21 11:00',
    '6/23/21 12:00',
    '6/23/21 13:00',
    '6/23/21 14:00',
    '6/23/21 15:00',
    '6/23/21 16:00',
    '6/23/21 17:00',
    '6/23/21 18:00',
    '6/23/21 19:00',
    '6/23/21 20:00',
    '6/23/21 21:00',
    '6/23/21 22:00',
    '6/23/21 23:00',
    '6/24/21 0:00',
    '6/24/21 1:00',
    '6/24/21 2:00',
    '6/24/21 3:00',
    '6/24/21 4:00',
    '6/24/21 5:00',
    '6/24/21 6:00',
    '6/24/21 7:00',
    '6/24/21 8:00',
    '6/24/21 9:00',
    '6/24/21 10:00',
    '6/24/21 11:00',
    '6/24/21 12:00',
    '6/24/21 13:00',
    '6/24/21 14:00',
    '6/24/21 15:00',
    '6/24/21 16:00',
    '6/24/21 17:00',
    '6/24/21 18:00',
    '6/24/21 19:00',
    '6/24/21 20:00',
    '6/24/21 21:00',
    '6/24/21 22:00',
    '6/24/21 23:00',
    '6/25/21 0:00',
    '6/25/21 1:00',
    '6/25/21 2:00',
    '6/25/21 3:00',
    '6/25/21 4:00',
    '6/25/21 5:00',
    '6/25/21 6:00',
    '6/25/21 7:00',
    '6/25/21 8:00',
    '6/25/21 9:00',
    '6/25/21 10:00',
    '6/25/21 11:00',
    '6/25/21 12:00',
    '6/25/21 13:00',
    '6/25/21 14:00',
    '6/25/21 15:00',
    '6/25/21 16:00',
    '6/25/21 17:00',
    '6/25/21 18:00',
    '6/25/21 19:00',
    '6/25/21 20:00',
    '6/25/21 21:00',
    '6/25/21 22:00',
    '6/25/21 23:00',
    '6/26/21 0:00',
    '6/26/21 1:00',
    '6/26/21 2:00',
    '6/26/21 3:00',
    '6/26/21 4:00',
    '6/26/21 5:00',
    '6/26/21 6:00',
    '6/26/21 7:00',
    '6/26/21 8:00',
    '6/26/21 9:00',
    '6/26/21 10:00',
    '6/26/21 11:00',
    '6/26/21 12:00',
    '6/26/21 13:00',
    '6/26/21 14:00',
    '6/26/21 15:00',
    '6/26/21 16:00',
    '6/26/21 17:00',
    '6/26/21 18:00',
    '6/26/21 19:00',
    '6/26/21 20:00',
    '6/26/21 21:00',
    '6/26/21 22:00',
    '6/26/21 23:00',
    '6/27/21 0:00',
    '6/27/21 1:00',
    '6/27/21 2:00',
    '6/27/21 3:00',
    '6/27/21 4:00',
    '6/27/21 5:00',
    '6/27/21 6:00',
    '6/27/21 7:00',
    '6/27/21 8:00',
    '6/27/21 9:00',
    '6/27/21 10:00',
    '6/27/21 11:00',
    '6/27/21 12:00',
    '6/27/21 13:00',
    '6/27/21 14:00',
    '6/27/21 15:00',
    '6/27/21 16:00',
    '6/27/21 17:00',
    '6/27/21 18:00',
    '6/27/21 19:00',
    '6/27/21 20:00',
    '6/27/21 21:00',
    '6/27/21 22:00',
    '6/27/21 23:00',
    '6/28/21 0:00',
    '6/28/21 1:00',
    '6/28/21 2:00',
    '6/28/21 3:00',
    '6/28/21 4:00',
    '6/28/21 5:00',
    '6/28/21 6:00',
    '6/28/21 7:00',
    '6/28/21 8:00',
    '6/28/21 9:00',
    '6/28/21 10:00',
    '6/28/21 11:00',
    '6/28/21 12:00',
    '6/28/21 13:00',
    '6/28/21 14:00',
    '6/28/21 15:00',
    '6/28/21 16:00',
    '6/28/21 17:00',
    '6/28/21 18:00',
    '6/28/21 19:00',
    '6/28/21 20:00',
    '6/28/21 21:00',
    '6/28/21 22:00',
    '6/28/21 23:00',
    '6/29/21 0:00',
    '6/29/21 1:00',
    '6/29/21 2:00',
    '6/29/21 3:00',
    '6/29/21 4:00',
    '6/29/21 5:00',
    '6/29/21 6:00',
    '6/29/21 7:00',
    '6/29/21 8:00',
    '6/29/21 9:00',
    '6/29/21 10:00',
    '6/29/21 11:00',
    '6/29/21 12:00',
    '6/29/21 13:00',
    '6/29/21 14:00',
    '6/29/21 15:00',
    '6/29/21 16:00',
    '6/29/21 17:00',
    '6/29/21 18:00',
    '6/29/21 19:00',
    '6/29/21 20:00',
    '6/29/21 21:00',
    '6/29/21 22:00',
    '6/29/21 23:00',
    '6/30/21 0:00',
    '6/30/21 1:00',
    '6/30/21 2:00',
    '6/30/21 3:00',
    '6/30/21 4:00',
    '6/30/21 5:00',
    '6/30/21 6:00',
    '6/30/21 7:00',
    '6/30/21 8:00',
    '6/30/21 9:00',
    '6/30/21 10:00',
    '6/30/21 11:00',
    '6/30/21 12:00',
    '6/30/21 13:00',
    '6/30/21 14:00',
    '6/30/21 15:00',
    '6/30/21 16:00',
    '6/30/21 17:00',
    '6/30/21 18:00',
    '6/30/21 19:00',
    '6/30/21 20:00',
    '6/30/21 21:00',
    '6/30/21 22:00',
    '6/30/21 23:00',
  ],
  datasets: [
    {
      label: false,
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [
        47.5,
        44.6,
        45.2,
        48.1,
        44.8,
        46.9,
        46.8,
        49.6,
        49.8,
        47.3,
        44.1,
        51.8,
        50.0,
        44.5,
        47.2,
        45.1,
        43.2,
        49.0,
        44.1,
        42.3,
        46.8,
        48.6,
        43.2,
        42.9,
        46.9,
        42.4,
        48.8,
        51.3,
        46.6,
        47.5,
        49.4,
        47.8,
        43.1,
        48.5,
        44.2,
        41.5,
        46.5,
        49.8,
        45.9,
        41.4,
        50.3,
        49.5,
        44.2,
        48.7,
        45.0,
        42.1,
        42.5,
        48.8,
        44.9,
        41.1,
        46.4,
        52.6,
        43.8,
        46.7,
        44.4,
        49.5,
        43.1,
        53.7,
        47.6,
        44.1,
        44.4,
        50.0,
        50.0,
        46.1,
        46.5,
        44.7,
        47.5,
        47.6,
        46.8,
        49.1,
        52.9,
        47.8,
        48.2,
        46.4,
        47.2,
        44.3,
        45.3,
        46.4,
        50.1,
        44.1,
        42.2,
        46.3,
        46.8,
        44.1,
        47.8,
        51.9,
        46.7,
        45.0,
        50.7,
        43.8,
        49.8,
        42.3,
        44.2,
        47.7,
        47.1,
        39.5,
        50.8,
        42.5,
        52.7,
        46.3,
        49.1,
        48.6,
        47.8,
        45.2,
        48.2,
        45.3,
        46.0,
        40.5,
        44.7,
        53.9,
        47.9,
        42.9,
        50.3,
        46.9,
        46.9,
        45.5,
        45.9,
        47.0,
        44.0,
        47.0,
        46.8,
        43.9,
        47.9,
        46.1,
        48.1,
        47.8,
        45.8,
        47.0,
        48.7,
        43.1,
        46.5,
        47.9,
        49.6,
        43.9,
        48.9,
        46.0,
        43.4,
        40.3,
        48.1,
        44.2,
        50.7,
        46.5,
        51.1,
        44.1,
        42.6,
        48.3,
        45.8,
        45.6,
        42.4,
        47.3,
        44.2,
        44.3,
        47.1,
        48.9,
        44.3,
        46.0,
        50.7,
        49.7,
        45.8,
        49.7,
        43.6,
        48.4,
        42.3,
        48.2,
        45.9,
        46.4,
        46.3,
        47.0,
        44.5,
        47.6,
        46.9,
        50.4,
        47.2,
        49.4,
        46.1,
        43.6,
        48.2,
        50.1,
        45.7,
        41.9,
        39.1,
        50.3,
        44.1,
        53.2,
        44.5,
        46.5,
        45.3,
        49.5,
        44.7,
        45.4,
        45.1,
        47.3,
        44.6,
        47.5,
        41.7,
        41.4,
        46.3,
        52.1,
        48.3,
        47.6,
        43.6,
        46.6,
        48.2,
        47.9,
        48.7,
        44.8,
        49.2,
        42.0,
        49.8,
        48.1,
        45.6,
        47.6,
        48.5,
        49.8,
        46.5,
        40.0,
        44.6,
        45.9,
        42.9,
        45.6,
        43.8,
        46.7,
        47.4,
        46.9,
        47.6,
        45.0,
        48.5,
        44.3,
        49.7,
        50.2,
        47.3,
        48.3,
        49.3,
        46.5,
        49.1,
        48.4,
        47.9,
        46.0,
        48.8,
        45.0,
        46.8,
        46.0,
        46.7,
        47.7,
        50.3,
        45.7,
        47.5,
        48.0,
        43.3,
        40.2,
        46.0,
        46.3,
        47.3,
        45.9,
        48.0,
        45.4,
        42.0,
        51.2,
        51.9,
        44.0,
        47.9,
        46.4,
        43.5,
        45.8,
        45.9,
        42.8,
        43.6,
        42.1,
        43.7,
        43.6,
        49.0,
        44.1,
        42.9,
        47.3,
        49.3,
        45.6,
        47.1,
        50.6,
        42.9,
        46.6,
        49.5,
        48.6,
        45.8,
        49.2,
        48.1,
        41.2,
        42.7,
        44.7,
        43.4,
        51.4,
        50.4,
        51.6,
        48.9,
        47.0,
        48.7,
        44.2,
        49.1,
        47.7,
        49.4,
        44.5,
        48.4,
        48.2,
        46.7,
        48.8,
        49.6,
        49.3,
        43.4,
        47.8,
        46.4,
        47.0,
        43.5,
        41.5,
        44.3,
        45.7,
        47.2,
        44.8,
        50.2,
        44.8,
        41.8,
        46.0,
        44.9,
        48.7,
        45.5,
        50.3,
        46.3,
        43.3,
        47.3,
        42.2,
        50.0,
        43.8,
        40.3,
        46.3,
        44.6,
        43.5,
        46.7,
        40.4,
        43.1,
        51.0,
        47.2,
        48.4,
        43.5,
        43.2,
        45.7,
        43.9,
        42.8,
        44.1,
        40.6,
        47.6,
        49.4,
        44.4,
        41.5,
        47.3,
        45.6,
        45.9,
        46.7,
        49.1,
        43.7,
        42.6,
        46.5,
        51.4,
        50.0,
        48.1,
        41.2,
        44.1,
        49.4,
        42.8,
        41.6,
        47.5,
        43.1,
        43.1,
        49.1,
        47.1,
        49.6,
        45.2,
        48.9,
        44.4,
        47.5,
        47.7,
        48.1,
        44.2,
        43.9,
        37.6,
        47.7,
        44.9,
        48.0,
        49.6,
        47.9,
        44.7,
        49.3,
        47.5,
        47.3,
        41.5,
        46.3,
        42.1,
        52.7,
        49.2,
        50.9,
        43.6,
        47.5,
        49.6,
        47.1,
        46.8,
        47.3,
        48.8,
        46.3,
        46.1,
        49.7,
        47.9,
        40.7,
        43.8,
        47.8,
        47.6,
        43.9,
        44.5,
        47.5,
        47.5,
        46.7,
        46.0,
        48.3,
        44.3,
        47.0,
        50.1,
        49.0,
        42.6,
        45.1,
        44.1,
        50.6,
        47.5,
        43.4,
        44.7,
        41.2,
        39.5,
        47.0,
        45.9,
        45.3,
        49.7,
        47.0,
        47.0,
        44.3,
        50.7,
        44.2,
        53.2,
        44.7,
        45.6,
        46.5,
        52.1,
        44.5,
        51.7,
        43.2,
        42.8,
        44.2,
        44.1,
        48.2,
        43.7,
        44.6,
        53.2,
        43.2,
        46.6,
        46.9,
        47.5,
        42.8,
        51.0,
        47.7,
        45.8,
        46.1,
        45.2,
        47.3,
        50.2,
        41.6,
        49.4,
        44.8,
        47.8,
        44.3,
        44.0,
        43.8,
        51.0,
        44.1,
        48.9,
        45.5,
        43.1,
        49.4,
        48.1,
        48.4,
        48.7,
        48.5,
        46.1,
        49.0,
        46.8,
        45.5,
        46.2,
        46.2,
        47.3,
        36.8,
        40.1,
        46.7,
        47.6,
        47.3,
        48.6,
        49.6,
        51.0,
        49.6,
        48.4,
        44.7,
        40.8,
        43.5,
        50.5,
        43.3,
        49.6,
        42.7,
        39.6,
        38.2,
        45.0,
        43.7,
        49.6,
        48.6,
        47.4,
        42.3,
        45.6,
        42.9,
        45.4,
        46.6,
        48.1,
        49.5,
        45.6,
        53.1,
        44.3,
        44.6,
        47.4,
        49.4,
        47.1,
        41.4,
        39.4,
        44.5,
        45.3,
        42.6,
        43.6,
        44.9,
        49.8,
        45.6,
        50.5,
        49.2,
        46.5,
        51.5,
        44.0,
        44.5,
        50.3,
        48.2,
        49.1,
        39.7,
        45.6,
        46.0,
        46.3,
        46.6,
        42.6,
        51.5,
        46.2,
        47.2,
        47.6,
        50.6,
        41.7,
        49.4,
        46.2,
        49.2,
        52.4,
        47.7,
        44.6,
        44.8,
        49.8,
        46.7,
        43.7,
        44.8,
        48.7,
        44.9,
        40.6,
        50.2,
        50.1,
        44.7,
        46.9,
        50.8,
        44.5,
        41.7,
        40.2,
        47.4,
        46.1,
        42.1,
        46.4,
        48.3,
        50.0,
        42.2,
        48.0,
        41.0,
        44.2,
        40.8,
        53.3,
        43.3,
        51.9,
        46.7,
        51.2,
        45.7,
        48.9,
        43.2,
        45.4,
        43.8,
        43.7,
        41.4,
        47.5,
        48.4,
        49.6,
        48.4,
        45.6,
        49.9,
        45.8,
        46.2,
        51.3,
        46.6,
        46.5,
        44.9,
        50.9,
        45.1,
        47.7,
        48.1,
        48.9,
        51.9,
        45.6,
        46.2,
        43.1,
        49.3,
        49.0,
        47.6,
        47.1,
        46.4,
        47.0,
        45.1,
        43.3,
        45.3,
        48.1,
        46.3,
        45.0,
        42.7,
        41.6,
        47.6,
        42.8,
        45.9,
        49.2,
        47.1,
        45.3,
        49.6,
        49.9,
        43.4,
        49.6,
        47.0,
        49.3,
        51.1,
        49.7,
        42.8,
        48.2,
        47.5,
        49.3,
        44.9,
        45.0,
        44.8,
        45.1,
        49.2,
        49.0,
        45.0,
        47.1,
        44.6,
        49.2,
        42.0,
        48.7,
        46.4,
        49.2,
        43.9,
        45.4,
        52.3,
        46.1,
        44.3,
        49.4,
        50.3,
        47.6,
        49.0,
        44.0,
        47.2,
        48.3,
        45.0,
        49.9,
        48.4,
        50.1,
        45.6,
        45.1,
        47.3,
        47.3,
        48.0,
        44.8,
        48.5,
        44.4,
        48.1,
        53.4,
        52.0,
        47.0,
        49.8,
        47.5,
        48.2,
        46.8,
        46.0,
        42.6,
        44.4,
        45.9,
        46.9,
        48.0,
        46.8,
        45.0,
        47.2,
        45.2,
        49.8,
        50.0,
        48.5,
        51.9,
        42.5,
        47.9
      ]
    }
  ]
};

export default class SampleLineChart extends React.Component {
  render() {
    return (
      <div>
        <Line
          ref="chart"
          data={data}
          options={{
            title: {
              display: false
            },
            legend: {
              display: false
            }
          }}
        />
      </div>
    );
  }
}
